import Splide from '@splidejs/splide';

let topbarUsps = document.querySelector('.topbar-usps');

if (topbarUsps) {
    let splide = new Splide(topbarUsps, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        rewind: true,
        pagination: false,
        arrows: false,
        width: '100%',
        destroy: true,

        breakpoints: {
            640: {
                perPage: 1,
                destroy: false,
                autoplay: true,
                interval: 3000
            },
        }
    });

    splide.mount();
}

document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');

    if (!link || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const url = new URL(link.href, window.location.href);
    const isCurrentPage = url.origin === window.location.origin
        && url.pathname === window.location.pathname
        && url.search === window.location.search;
    const target = url.hash && document.getElementById(decodeURIComponent(url.hash.slice(1)));

    if (!isCurrentPage || !target) {
        return;
    }

    event.preventDefault();

    const startPosition = window.scrollY;
    const targetPosition = target.getBoundingClientRect().top + startPosition;
    const distance = targetPosition - startPosition;
    const duration = 1200;
    const startTime = performance.now();

    const scroll = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easedProgress = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        window.scrollTo(0, startPosition + distance * easedProgress);

        if (progress < 1) {
            requestAnimationFrame(scroll);
            return;
        }

        window.history.pushState(null, '', url.hash);
    };

    requestAnimationFrame(scroll);
});
